import React, { useMemo, useState } from 'react';

import theme from '@/constants/theme';
import Tabs from '@/components/dataDisplay/Tabs';
import QuizReader from '@/components/interactive/Quiz/QuizReader';
import { MarkdownReader } from '@/components/dataDisplay/MarkdownReader';
import PrivacyNote from '../PrivacyNote';

interface Props {
  quizData?: string;
  quizResponses?: string;
  onSaveUserResponses?: (userResponses: string) => void;
}

const QuizSummary: React.FC<Props> = ({ quizData, quizResponses, onSaveUserResponses }) => {
  const [tab, setTab] = useState(0);

  const analysis = useMemo(() => {
    if (!quizResponses) return null;
    return JSON.parse(quizResponses).analysis;
  }, [quizResponses]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, flex: 1, overflow: 'auto' }}>
      {analysis && (
        <Tabs
          tabs={[
            { id: 0, label: 'Respuestas' },
            { id: 1, label: 'Análisis' },
          ]}
          currentTab={tab}
          setCurrentTab={setTab}
        />
      )}
      {tab === 0 && (
        <>
          <PrivacyNote />
          <QuizReader
            quizData={quizData}
            responses={quizResponses}
            onSaveUserResponses={onSaveUserResponses}
          />
        </>
      )}
      {tab === 1 && (
        <div
          style={{
            overflow: 'auto',
            maxHeight: '100%',
            padding: 16,
            backgroundColor: theme.colors.background.secondary,
            borderRadius: 8,
          }}
        >
          <MarkdownReader>{analysis}</MarkdownReader>
        </div>
      )}
    </div>
  );
};

export default QuizSummary;
